import React from 'react';
import Checkbox24 from '@alltrails/shared/components/Checkbox24';
import InputList from '@alltrails/shared/components/InputList';
import { Variant } from '@alltrails/shared/components/FormSelectorBase';
import { FilterConfigToggle, FilterConfigToggleKey } from 'types/Search';

export type Props = {
  className?: string;
  config: FilterConfigToggle;
  filterName: string;
  handler: (changes: FilterConfigToggle) => void;
  useColumns?: boolean;
  variant?: Variant;
};

const onChange = (config: FilterConfigToggle, selectedKey: FilterConfigToggleKey) => ({
  ...config,
  [selectedKey]: {
    ...config[selectedKey],
    selected: !config[selectedKey].selected
  }
});

const CheckboxGroup = ({ className = '', filterName, config, handler, useColumns, variant = Variant.DEFAULT }: Props) => (
  <InputList useColumns={useColumns}>
    {Object.keys(config).map((key: FilterConfigToggleKey) => {
      const option = config[key];

      return (
        <Checkbox24
          className={className}
          id={key}
          key={`${filterName}:${key}`}
          name={filterName}
          value={key}
          checked={option.selected}
          onChange={() => handler(onChange(config, key))}
          inputType="checkbox"
          labelComponent={<>{option.name}</>}
          variant={variant}
        />
      );
    })}
  </InputList>
);

export default CheckboxGroup;
